import { Typography, Grid, Button, Card, Link } from '@mui/material'
import colors from '../../colors'
import React from 'react'
import SinglePopularQuestion from './SinglePopularQuestion'
import { useDispatch, useSelector } from 'react-redux'
import { sendGeneralRequest } from '../../../features/generalRequest'
import { useNavigate } from 'react-router-dom'
import { selectPopulartQuestionsState } from '../../../features/popularQuestions/popularQuestionsSlice'
import { ReactComponent as IconClose } from '../../../icons/closeButton.svg';
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts'

export const PopularQuestions = (props) => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const popularQuestionsSliceState = useSelector(selectPopulartQuestionsState)

  React.useEffect(()=>{
    dispatch(sendGeneralRequest({request: {}, baseUrlKey:'auth', endpoint:'FrequentlyAskedQuestions'}))
  },[])

  const useStyles = makeStyles({
    header:{
      fontSize:'2rem',
      fontFamily:'GerberaBold',
      color:colors.darkBlue
    },
    button:{
      fontSize:'1.8rem',
      color:colors.orange,
      borderRadius:'20px',
      '&:hover': {background:colors.white}
    },
    card:{
      width:'50%',
      background:colors.cyan,
      borderRadius:'20px',
      boxShadow:'0 0 15px 5px #E5E7EA',
      '@media (max-width: 899px )' : {width:'90%'}
    },
    contactUsGrid:{
      marginTop: 10,
      marginBottom: 30,
      background:colors.cyan,
      borderRadius:'20px'
    },
    text:{
      fontFamily:'GerberaLight',
      color:colors.darkBlue
    },
    link:{
      color:colors.orange,
      textDecoration:'none',
      fontFamily:'GerberaLight', 
      "&:hover":{textDecorationColor:'#FF8403', textDecoration:'underline', color:'#FF8403'}
    }
  })

  const classes = useStyles()


  return (
    <Grid container justifyContent={'center'} >
      <Grid container justifyContent={'center'} pt={10} >
        <Grid container  item md={6} xs={10} justifyContent={'center'} >
          <Typography className={classes.header}>{texts["title-faq"]}</Typography>
        </Grid>
        <Grid container  item md={4.5} xs={2} justifyContent={'center'} >
          <Button className={classes.button} onClick={() => {navigate(-1)}} ><IconClose /></Button>
        </Grid>
      </Grid>
      <Grid container  mt={10} pb={5} justifyContent={'center'} >
        <Card  className={classes.card} >
          {popularQuestionsSliceState.popularQuestions.map((popularQuestion, index) => 
              {
                return <SinglePopularQuestion key={index} question={popularQuestion.question} answer={popularQuestion.answer}  />
              })
          }
        </Card>
        
      </Grid>
      <Grid container item md={5} xs={11} justifyContent={'center'} alignContent={'center'} direction={'column'} className={classes.contactUsGrid} >
          <Typography mt={2} className={classes.text} >{texts["message-faq-not-found"]}</Typography>
          <Link mt={1} mb={2} className={classes.link} href='https://easypay.al/support.html' target="_blank" >{texts["button-contact-us"]}</Link>
        </Grid>
    </Grid>
  )
}
export default PopularQuestions